// src/CryptoHeatmapPage.js
import React from 'react';
import CryptoHeatmap from './componets/CryptoHeatmap';
import './HeatmapPage.css';

function CryptoHeatmapPage() {
  return (
    <div className="heatmap-page">
      <h1>Crypto Market Heatmap</h1>
      <div className="heatmap-container">
        <CryptoHeatmap />
      </div>
    </div>
  );
}

export default CryptoHeatmapPage;
